// extracted by mini-css-extract-plugin
module.exports = {"container":"SidebarOpenButtonPeriodClosed_container__30c0i","icon-update":"SidebarOpenButtonPeriodClosed_icon-update__20zlr"};